<script setup>
import {defineEmits, defineProps} from 'vue'

defineProps({
    color: String,
    text: [String, Number, Object],
    icon: String,
    iconColor: String,
    outlined: Boolean,
});

const emit = defineEmits(['chipClick']);

function chipClick() {
    emit('chipClick');
}
</script>

<template>
    <v-chip
        v-if="text !== null && text !== undefined && text !== ''"
        small
        :class="color ? 'ma-1 white--text' : 'ma-1'"
        :outlined="outlined"
        :color="color"
        @click="chipClick"
    >
        <strong>{{ text }}</strong>
        <v-icon
            v-if="icon"
            right
            small
            :color="iconColor"
        >
            {{ icon }}
        </v-icon>
    </v-chip>
</template>